import ReportsBusinessTable from "../../features/reports/components/reports-business-table/ReportsBusinessTable";

export default function ReportsPage() {
  return (
    <div>
      <ReportsBusinessTable />
    </div>
  );
}
